import { render, staticRenderFns } from "./SinGrupos.vue?vue&type=template&id=da440678&scoped=true"
var script = {}
import style0 from "./SinGrupos.vue?vue&type=style&index=0&id=da440678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da440678",
  null
  
)

export default component.exports